
export enum EProcessStatus {
    None,
    Draft,
    InProgress,
    Cancelled,
    Rejected,
    Finished,
    WaitingForMe,
    WaitingForOthers,
    Expired,
    Inactive
}